// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__lD6Rv","info":"Panel_info__1mW7y","note":"Panel_note__VksxT","close":"Panel_close__1Rohc","btns":"Panel_btns__Uv8LQ","button":"Panel_button__eDbgl"};